/**
 * Full label for the in-app notification "View" button.
 * Server notifications often use technical `event` keys (e.g. courses:expired);
 * those are mapped here. Human-readable events (e.g. "Action Point", scheduled event titles)
 * fall back to `View ${event}` in the component.
 */
export const NOTIFICATION_VIEW_BUTTON_BY_EVENT = {
    'team:invite-accepted': 'View invitation',

    'courses:assigned': 'View course',
    'courses:expired': 'View course',

    'audits:assigned': 'View audit',
    'audit:uploaded': 'View audit',

    'inventory:low-stock': 'View inventory',
    'item:low-stock': 'View inventory',

    'library:expired': 'View document',
    'library:review-requested': 'Review document',
    'library:uploaded': 'View document',

    'support:chat:created': 'Open chat',
};

/**
 * @param {string | null | undefined} event
 * @returns {string}
 */
export function getNotificationViewButtonLabel(event) {
    if (!event || typeof event !== 'string') {
        return 'View details';
    }
    if (
        Object.prototype.hasOwnProperty.call(
            NOTIFICATION_VIEW_BUTTON_BY_EVENT,
            event
        )
    ) {
        return NOTIFICATION_VIEW_BUTTON_BY_EVENT[event];
    }
    return `View ${event}`;
}
